<template>
  <div class="home">
    <Looking :info="info" :mobile="mobile" />
    <Trust :info="info" :mobile="mobile" />
    <Difference :info="info" :mobile="mobile" />
    <Contact :info="info" :mobile="mobile" />
  </div>
</template>

<script>
import Contact from '@/components/banners/contact'
import Looking from '@/components/banners/looking'
import Trust from '@/components/banners/trust'
import Difference from '@/components/banners/difference'
import Form from '@/components/Form2'
export default {
  name: 'Home',
  props: ['info', 'mobile'],
  components: { Form, Looking, Trust, Difference, Contact }
};
</script>

<style scoped>
</style>